module.exports = __webpack_public_path__ + "static/img/img_cabinet.ad3a13b5.png";